// Helper class for automatic pattern selector

class GroupSpec
{
  constructor() {
    this.firstIndex = -1;
    this.lastIndex = -1;
    this.pattern = [];
  }
  
  toString() {
    JSON.stringify(this);
  }
};

export default GroupSpec
